/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  selector: "taku-google-shopping-consent-confirmation",
  templateUrl: "./google-shopping-consent-confirmation.component.html",
  styleUrls: ["./google-shopping-consent-confirmation.component.scss"],
})
export class GoogleShoppingConsentConfirmationComponent implements OnInit {
  constructor(private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

  ngOnInit() {}

  onContinuePressed() {
    this.dialogRef.close({
      success: true,
    });
  }

  anotherIntegratorLinkPressed() {
    this.dialogRef.close();
  }
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
